export const AVAX_TESTNET_TOKEN_LIST = {
  name: 'KyberSwap Token List',
  keywords: ['kyberswap', 'dmmexchange'],
  timestamp: '2020-12-12T00:00:00+00:00',
  tokens: [
    // {
    //   chainId: 43113,
    //   address: '0x51E8D106C646cA58Caf32A47812e95887C071a62',
    //   symbol: 'KNC',
    //   name: 'Kyber Network Crystal',
    //   decimals: 18
    // },
    {
      chainId: 43113,
      address: '0x5973774202E8b0ad563A69D502bb0e670e7d00Dd',
      symbol: 'USDC',
      name: 'USDC',
      decimals: 6,
    },
    {
      chainId: 43113,
      address: '0xBD1EEAf651aEB210106E1c1aFb3BC41C388ee577',
      symbol: 'USDT',
      name: 'USDT',
      decimals: 6,
    },
    {
      chainId: 43113,
      address: '0xE50c0F38a1890Db49d64ac1C4A5B4fe2f02f819d',
      symbol: 'DAI',
      name: 'DAI',
      decimals: 18,
    },
    {
      chainId: 43113,
      address: '0xd00ae08403B9bbb9124bB305C09058E32C39A48c',
      symbol: 'WAVAX',
      name: 'Wrapped AVAX',
      decimals: 18,
    },
  ],
  version: {
    major: 0,
    minor: 0,
    patch: 0,
  },
}
